import type { IconSvgObject } from './types';

const Medal07Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "16.5", r: "5.5", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 11L4 8V2H20V8L13 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 11V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "12", cy: "16.5", r: "1.5", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default Medal07Icon;
